import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import BILLING_ENUMS from './constants';
import {
  BillingMessage,
  WelcomePrompt,
  UpdatePaymentMethod,
} from './modals';

class BillingPrompt extends Component {
  shouldDisplayPrompt = () => {
    const lastDismissTime = localStorage.getItem('m8_prompt_dismissed_time');
    // If users have never seen billing prompt, display
    if (!lastDismissTime || isNaN(new Date(lastDismissTime))) return true;

    const { billingTrialDetails } = this.props;

    const {
      trial_days_remaining: daysRemainingInTrial,
    } = billingTrialDetails;

    const currentTime = moment(new Date().toISOString());
    // How much time has passed between now and the last time they dismissed the modal
    const timeDifference = moment.duration(currentTime - moment(lastDismissTime));
    // Always display if user is on the last day or the trial is finished
    if (daysRemainingInTrial <= 1) {
      return true;
    }

    if (daysRemainingInTrial <= 7) {
      // Display prompt every single day once 7 days remain.
      // Wait until at least one day has passed before showing prompt again
      if (timeDifference._data.days >= 1) return true;
    }

    if (daysRemainingInTrial > 7) {
      // Display prompt a week when there is at least one week left
      // Wait until at least a week has passed before showing prompt again
      if (timeDifference._data.days > 6) return true;
    }
    return false;
  }

  isValidEndDate = () => {
    const { billingTrialDetails } = this.props;
    return billingTrialDetails && billingTrialDetails.trial_end_date !== 'none';
  }

  isBillingValid = () => {
    const { billingTrialDetails, planType } = this.props;
    return billingTrialDetails && billingTrialDetails.billing_on_file === true && (planType !== 'cancelled' && planType !== 'revoked');
  }

  isFirstTime = () => {
    const { billingTrialDetails } = this.props;
    const lastDismissTime = localStorage.getItem('m8_prompt_dismissed_time');
    const noEndDate = billingTrialDetails.trial_end_date === 'none';
    if (!lastDismissTime && !noEndDate && billingTrialDetails.trial_days_remaining > 0) return true;
    return false;
  }

  closeModal = () => {
    const MODAL_CLOSE = -1;
    const { changeModal } = this.props;
    changeModal(MODAL_CLOSE, false);
  }

  render() {
    const { modalState, modalOpen } = this.props;
    const { closeModal } = this;
    const { UPDATE_PAYMENT_METHOD } = BILLING_ENUMS;
    const validBilling = this.isBillingValid();
    const validEndDate = this.isValidEndDate();
    const shouldDisplayPrompt = this.shouldDisplayPrompt();

    // Payment-method management is the only billing mutation still available in-app.
    if (modalState === UPDATE_PAYMENT_METHOD && modalOpen) {
      return <UpdatePaymentMethod {...this.props} closeModal={closeModal} />;
    }

    // Do not show a subscription purchase or upgrade prompt in the app. Customers
    // who need a plan should contact Medsender outside the app.
    if (validBilling || !shouldDisplayPrompt || !validEndDate) return null;

    if (this.isFirstTime() && !validBilling) return (<WelcomePrompt {...this.props} />);
    return (<BillingMessage {...this.props} />);
  }
}

BillingPrompt.defaultProps = {
  modalState: BILLING_ENUMS.MODAL_CLOSE,
};

BillingPrompt.propTypes = {
  modalState: PropTypes.number,
  modalOpen: PropTypes.bool.isRequired,
  changeModal: PropTypes.func.isRequired,
};

export default BillingPrompt;
